import { useCallback } from 'react';
import MBSwitch from 'components/Elements/MBSwitch/MBSwitch';
import * as Styled from './CollectionsView.styles';
import { CollectionCarousel } from '../../../../../../../../MIT/Search/view/frontend/pages/ProductSearch/containers/CollectionsCarouselContainer/CollectionCarousel';
import { CategoryFilter } from '../../components/CategoryFilter/CategoryFilter';
import { CollectionGrid } from '../../components/CollectionGrid/CollectionGrid';
import { ListView } from '../../components/ListView/ListView';
import {
  useViewMode,
  useFiltersPosition,
  useCategoryChange,
} from '../../hooks';
import { useTranslateCollections } from '../../i18n';

import { categoryFacetType, sortedCollectionsType } from '../../types';

interface CollectionsViewProps {
  collections: sortedCollectionsType[];
  facets: categoryFacetType;
}

export const CollectionsView = ({
  collections,
  facets,
}: CollectionsViewProps) => {
  const t = useTranslateCollections();
  const { selectedCategoryId, handleCategoryChange } =
    useCategoryChange(collections);

  const { stickyTop } = useFiltersPosition();
  const { isListView, handleViewMode } = useViewMode();

  const renderCollections = useCallback(() => {
    if (isListView) {
      return (
        <ListView
          actionLabel={t('See all')}
          sortedCollections={collections.filter(
            (collection) =>
              !selectedCategoryId ||
              collection.category_id === selectedCategoryId,
          )}
          selectedCategoryId={selectedCategoryId}
          onSeeAllClick={handleCategoryChange}
        />
      );
    }

    return selectedCategoryId ? (
      <CollectionGrid
        collection={collections.find(
          (collection) => collection.category_id === selectedCategoryId,
        )}
      />
    ) : (
      collections.map((collectionSet: sortedCollectionsType, index: number) => {
        return (
          <CollectionCarousel
            key={collectionSet.category_id}
            title={collectionSet.label}
            campaigns={collectionSet.results}
            actionLabel={t('See all')}
            isFeatured={index === 0}
            isLoading={false}
            onSeeAllClick={() =>
              handleCategoryChange(collectionSet.category_id)
            }
            eventLocation={null}
            ctaPosition="left"
          />
        );
      })
    );
  }, [isListView, selectedCategoryId, collections, handleCategoryChange, t]);

  return (
    <Styled.Wrapper>
      <Styled.Header style={{ top: stickyTop }}>
        <CategoryFilter
          filterCategories={facets}
          selectedCategoryId={selectedCategoryId}
          onCategoryChange={handleCategoryChange}
        />
        <Styled.SwitchViewMode>
          <MBSwitch checked={isListView} onChange={handleViewMode} />
          <Styled.SwitchTitle>{t('List view')}</Styled.SwitchTitle>
        </Styled.SwitchViewMode>
      </Styled.Header>
      {renderCollections()}
    </Styled.Wrapper>
  );
};
